import { render, staticRenderFns } from "./holiday_list.vue?vue&type=template&id=49e8b87f&scoped=true"
import script from "./holiday_list.vue?vue&type=script&lang=js"
export * from "./holiday_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e8b87f",
  null
  
)

export default component.exports